import { gql } from '__generated__';

export const ParticipantFieldEntryFieldsFragment = gql(`
  fragment OrderParticipantFieldEntryFields on ParticipantFieldEntry {
    id
    field {
      id
    }
    value
    choice_entries {
      id
      choice {
        id
        title
        position
        enabled
      }
    }
  }
`);

export const ParticipantFieldFieldsFragment = gql(`
  fragment OrderParticipantFieldFields on ParticipantField {
    id
    title
    description
    type
    scope
    required_participant_attributes
    required_promotions {
      id
    }
    choices {
      id
      title
      position
      enabled
    }
    required
    config
    has_external_validation
  }
`);

export const OrderFieldsFragment = gql(`
  fragment BackendOrderFields on Order {
    id
    amount
    paid_amount
    refunded_amount
    remaining_amount
    invoice_amount
    credited_amount
    paid_passed_on_fee
    remaining_passed_on_fee
    invoice_id
    draft
    invoice_date
    due_date
    start_bank_transfer_payment
    cancel_after_due_date
    invoice_url
    dashboard_url
    company_name
    is_charity
    reference
    street
    house_number
    extra_address_line
    zip_code
    city
    country
    phone
    vat_id
    vat_id_editable
    cancelled
    waitlist
    preregistration
    deletable
    created_at
    event {
      id
      title
      start_date
      end_date
      payment_methods
      require_company_for_bank_transfer
    }
    participant_fields {
      ...OrderParticipantFieldFields
    }
    participant_field_entries {
      ...OrderParticipantFieldEntryFields
    }
    stand_alone_upgrades {
      id
      product {
        id
        title
      }
      promotion {
        id
        title
      }
      product_variant {
        id
        title
      }
      participant_fields {
        ...OrderParticipantFieldFields
      }
      participant_field_entries {
        ...OrderParticipantFieldEntryFields
      }
    }
    participant {
      id
      email
      first_name
      last_name
      city
      street
      zip_code
      house_number
      phone
      country
      extra_address_line
      balance
    }
    purchases(tickets_limit: $tickets_limit) {
      id
      balance
      amount
      paid_amount
      remaining_amount
      refunded_amount
      refundable_amount
      revenue
      batch_size
      unit_id
      active
      participant {
        id
        full_name
        active
      }
      coupon_code {
        id
        value
        coupon {
          id
          value
          type
        }
      }
      invitation_code {
        id
        value
      }
      registration {
        id
        sequence
        assigned
        full_name
        status
      }
      promotion {
        id
        title
        amount
      }
      product {
        id
        title
        position
      }
      product_variant {
        id
        title
      }
      ticket {
        id
        title
        units
        position
      }
      time_slot {
        id
        title
        multi_date
        start_date
        start_time
      }
    }
    purchases_count
    payments(order_by: "created_at", order_direction: "asc") {
      data {
        id
        payment_method
        amount
        status
        status_changed_at
        consumer_account
        created_at
        refunds(order_by: "created_at", order_direction: "asc") {
          data {
            id
            amount
            created_at
            status
          }
        }
      }
    }
  }
`);

export default gql(`
  query GetOrder($order_id: ID!, $tickets_limit: Int) {
    order(id: $order_id) {
      ...BackendOrderFields
    }
  }
`);
